(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("MicroviewReact"), require("MicroviewSharedWidgets"), require("MicroviewSharedUrls"), require("MicroviewReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["MicroviewReact", "MicroviewSharedWidgets", "MicroviewSharedUrls", "MicroviewReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["omniboxMicroview"] = factory(require("MicroviewReact"), require("MicroviewSharedWidgets"), require("MicroviewSharedUrls"), require("MicroviewReactDOM"));
	else
		root["omniboxMicroview"] = factory(root["MicroviewReact"], root["MicroviewSharedWidgets"], root["MicroviewSharedUrls"], root["MicroviewReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__33__, __WEBPACK_EXTERNAL_MODULE__58__) {
return 